import React from 'react';
import { GraduationCap, TreePine, HeartPulse, HandCoins } from 'lucide-react';
import { Layout } from './Home';
import PageHero from '../components/PageHero';
import { pageImages, csrPillars } from '../data/pages';

const ICONS = {
  Education: GraduationCap,
  Environment: TreePine,
  'Health & Wellness': HeartPulse,
  Livelihood: HandCoins,
};

const CSRPage = () => (
  <Layout>
    <PageHero
      eyebrow="Corporate Social Responsibility"
      title="Investing in people, planet and prosperity."
      description="Our CSR programmes create measurable impact across education, environment, health and livelihood — in the communities where we live and operate."
      image={pageImages.csr}
    />

    <section className="bg-[#e2ede6] py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {csrPillars.map((p) => {
            const Icon = ICONS[p.title] || GraduationCap;
            return (
              <div key={p.title} className="bg-white rounded-2xl p-6 border border-[#0f5c3d]/10 hover:border-[#0f5c3d]/40 transition-colors">
                <div className="w-12 h-12 rounded-xl bg-[#e2ede6] text-[#0f5c3d] flex items-center justify-center">
                  <Icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <h3
                  className="mt-5 text-2xl text-[#0b1a2e]"
                  style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
                >
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-[#0b1a2e]/70 leading-relaxed">{p.text}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {[
            { k: '25,000+', v: 'Scholarships funded' },
            { k: '120K+', v: 'Trees planted' },
            { k: '18', v: 'Community programmes active' },
          ].map((s) => (
            <div key={s.v} className="bg-gradient-to-br from-[#0f5c3d] to-[#137a52] text-white rounded-2xl p-8">
              <div
                className="text-5xl font-bold"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {s.k}
              </div>
              <div className="mt-2 text-white/85">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </Layout>
);

export default CSRPage;
